import { render } from "./MemberHistory.vue?vue&type=template&id=2916f734&scoped=true"
import script from "./MemberHistory.vue?vue&type=script&lang=js"
export * from "./MemberHistory.vue?vue&type=script&lang=js"

import "./MemberHistory.vue?vue&type=style&index=0&id=2916f734&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2916f734"]])

export default __exports__